module.exports = __webpack_public_path__ + "img/稻田.981726ee.svg";